var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 294"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 17",
    cx: 114,
    cy: 114,
    r: 111.731,
    stroke: "white",
    strokeWidth: 4.53731
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M162.777 106.84C168.071 109.896 168.071 117.537 162.777 120.593L95.1427 159.641C89.8492 162.698 83.2323 158.877 83.2323 152.765L83.2323 74.6675C83.2323 68.5551 89.8492 64.7348 95.1427 67.791L162.777 106.84Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoicon);
export default __webpack_public_path__ + "static/media/videoicon.14fb70670e77ea9739abe4d2fc43af2d.svg";
export { ForwardRef as ReactComponent };